"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _EmptyState = _interopRequireDefault(require("@insided/destination/icons/EmptyState"));

var NotificationCenterEmpty = function NotificationCenterEmpty() {
  return (0, _preact.h)("div", {
    className: "notification-center__empty"
  }, (0, _preact.h)("div", {
    className: "notification-center__empty__content"
  }, (0, _preact.h)("div", {
    className: "notification-center__empty__icon"
  }, (0, _preact.h)(_EmptyState.default, null)), (0, _preact.h)("div", {
    className: "notification-center__empty__text"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.noActivity"
  })), (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "notification.center.information.comeBack"
  })))));
};

var _default = NotificationCenterEmpty;
exports.default = _default;